export default {
  ORANGE_GRADIENT: 'ORANGE_GRADIENT',
  ORANGE_BKG_DARK_TXT: 'ORANGE_BKG_DARK_TXT',
  TRANSPARENT_BKG_GRAY_TXT: 'TRANSPARENT_BKG_GRAY_TXT',
  RED_BKG_WHITE_TXT: 'RED_BKG_WHITE_TXT',
  YELLOW_BKG_WHITE_TXT: 'YELLOW_BKG_WHITE_TXT',
  BLUE_BKG_WHITE_TXT: 'BLUE_BKG_WHITE_TXT',
  GREEN_BKG_WHITE_TXT: 'GREEN_BKG_WHITE_TXT',
  RED_BORDER_WHITE_TEXT: 'RED_BORDER_WHITE_TEXT',
  YELLOW_BORDER_WHITE_TEXT: 'YELLOW_BORDER_WHITE_TEXT',
  BLUE_BORDER_WHITE_TEXT: 'BLUE_BORDER_WHITE_TEXT',
  GREEN_BORDER_WHITE_TEXT: 'GREEN_BORDER_WHITE_TEXT'
}
